import type { Me } from '@ft/shared';

export type MeResult =
  | { kind: 'ok'; me: Me }
  | { kind: 'login' }
  | { kind: 'not_registered'; email: string; message: string }
  | { kind: 'error'; status: number | null };

export async function fetchMe(): Promise<MeResult> {
  try {
    const r = await fetch('/api/me', { credentials: 'same-origin' });
    if (r.status === 401) return { kind: 'login' };
    if (r.status === 403) {
      const b = (await r.json()) as { email: string; message: string };
      return { kind: 'not_registered', email: b.email, message: b.message };
    }
    if (!r.ok) return { kind: 'error', status: r.status };
    return { kind: 'ok', me: (await r.json()) as Me };
  } catch {
    return { kind: 'error', status: null };
  }
}

export interface Health { status: string; db: string; version: string }

export async function fetchHealth(): Promise<Health | null> {
  try {
    const r = await fetch('/api/health');
    return (await r.json()) as Health;
  } catch {
    return null;
  }
}

export function loginUrl(): string {
  return `/auth/login?returnTo=${encodeURIComponent(location.pathname + location.search)}`;
}
